/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { HelpDocument } from '../auth';



type Props = {
  className: string
  Documents: HelpDocument[];
}

const DocumentListWidget: React.FC<Props> = ({ className,Documents }) => {
  return (
    <div className={`card align-self-stretch ${className}`}>
      {/* begin::Header 
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'></span>
          <span className='text-muted mt-1 fw-bold fs-7'></span>
        </h3>

      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive' 

        >
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted bg-light'>
                  
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {
                Documents.map((document, index) => {
                  return (
                    <tr>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='symbol symbol-50px me-5'>
                            <span className='symbol-label bg-light'>
                              <img
                                src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
                                className='h-75 align-self-end'
                                alt=''
                              />
                            </span>
                          </div>
                          <div className='d-flex justify-content-start flex-column'>
                            <a
                              target='_blank'
                              rel="noreferrer"
                              href={`${document.Pdf}`}
                              className='text-dark fw-bolder text-hover-primary mb-1 fs-6'>
                              {document.DocumentName}
                            </a>

                          </div>
                        </div>
                      </td>

                      <td className='text-end'>
                        <a
                          target='_blank'
                          rel="noreferrer"
                          href={`${document.Pdf}`}
                          className='btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2'
                        >
                          View
                        </a>

                      </td>
                    </tr>
                  )

                }
                )
              }


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export { DocumentListWidget }
